import { render, staticRenderFns } from "./MultiFileUpload.vue?vue&type=template&id=6590a0ea"
import script from "./MultiFileUpload.vue?vue&type=script&lang=ts"
export * from "./MultiFileUpload.vue?vue&type=script&lang=ts"
import style0 from "./MultiFileUpload.vue?vue&type=style&index=0&id=6590a0ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports